module.exports = __webpack_public_path__ + "img/20240502080024985uz9.7613b9bc.jpg";